"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSportPlayByPlayEngine = exports.PlayByPlayEntry = exports.playByPlayEntry = exports.PlayByPlayState = exports.PlayByPlayType = void 0;
var tslib_1 = require("tslib");
var Immutable = tslib_1.__importStar(require("immutable"));
var engine = tslib_1.__importStar(require("../common/engine"));
var state = tslib_1.__importStar(require("../common/state"));
var controller_1 = require("../common/controller");
var definitions_1 = require("./events/definitions");
var play_by_play_commentary_1 = require("../hoops/play_by_play_commentary");
var PlayByPlayType;
(function (PlayByPlayType) {
    PlayByPlayType["Play"] = "play";
    PlayByPlayType["StartPeriod"] = "startPeriod";
    PlayByPlayType["EndPeriod"] = "endPeriod";
    PlayByPlayType["ImplicitPlayerActivate"] = "implicitPlayerActivate";
    PlayByPlayType["PlayerActivate"] = "playerActivate";
    PlayByPlayType["PlayerDeactivate"] = "playerDeactivate";
    PlayByPlayType["ScoreAdjustment"] = "scoreAdjustment";
    PlayByPlayType["ScoreOverride"] = "scoreOverride";
    PlayByPlayType["BeginPlay"] = "beginPlay";
    PlayByPlayType["EndPlay"] = "endPlay";
})(PlayByPlayType = exports.PlayByPlayType || (exports.PlayByPlayType = {}));
var PlayByPlayState = /** @class */ (function (_super) {
    tslib_1.__extends(PlayByPlayState, _super);
    function PlayByPlayState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PlayByPlayState.prototype, "isInProgress", {
        get: function () {
            return this.get(PlayByPlayState.isInProgressKey, false);
        },
        enumerable: false,
        configurable: true
    });
    PlayByPlayState.prototype.setInProgress = function (isInProgress) {
        return this.set(PlayByPlayState.isInProgressKey, isInProgress);
    };
    Object.defineProperty(PlayByPlayState.prototype, "inProgressEntries", {
        get: function () {
            return this.get(PlayByPlayState.inProgressEntriesKey);
        },
        enumerable: false,
        configurable: true
    });
    PlayByPlayState.prototype.pushInProgressEntry = function (inProgressEntry) {
        return this.updateIn([PlayByPlayState.inProgressEntriesKey], Immutable.List(), function (inProgressEntries) {
            return inProgressEntries.push(inProgressEntry);
        });
    };
    PlayByPlayState.prototype.clearInProgressEntries = function () {
        return this.set(PlayByPlayState.inProgressEntriesKey, Immutable.List());
    };
    Object.defineProperty(PlayByPlayState.prototype, "latestScorerStreaks", {
        get: function () {
            return this.get(PlayByPlayState.latestScorerStreakKey).toJS();
        },
        enumerable: false,
        configurable: true
    });
    PlayByPlayState.prototype.trackLatestScore = function (teamId, playerId) {
        var scorerStreaks = this.latestScorerStreaks;
        if (scorerStreaks[teamId]) {
            var oldTeamStreak = scorerStreaks[teamId];
            if (oldTeamStreak.playerId === playerId) {
                return this.setIn([PlayByPlayState.latestScorerStreakKey, teamId, 'playerId'], playerId).setIn([PlayByPlayState.latestScorerStreakKey, teamId, 'streakCount'], oldTeamStreak.streakCount + 1);
            }
            else {
                return this.setIn([PlayByPlayState.latestScorerStreakKey, teamId, 'playerId'], playerId).setIn([PlayByPlayState.latestScorerStreakKey, teamId, 'streakCount'], 1);
            }
        }
        return this.setIn([PlayByPlayState.latestScorerStreakKey, teamId, 'playerId'], playerId).setIn([PlayByPlayState.latestScorerStreakKey, teamId, 'streakCount'], 1);
    };
    PlayByPlayState.prototype.trackLatestMiss = function (teamId, playerId) {
        var scorerStreaks = this.latestScorerStreaks;
        if (scorerStreaks[teamId]) {
            var oldTeamStreak = scorerStreaks[teamId];
            if (oldTeamStreak.playerId === playerId) {
                return this.setIn([PlayByPlayState.latestScorerStreakKey, teamId, 'playerId'], playerId).setIn([PlayByPlayState.latestScorerStreakKey, teamId, 'streakCount'], 0);
            }
        }
        return this;
    };
    Object.defineProperty(PlayByPlayState.prototype, "allEntriesImmutable", {
        get: function () {
            return this.get(PlayByPlayState.entriesKey);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlayByPlayState.prototype, "allEntries", {
        get: function () {
            return this.allEntriesImmutable.toJS();
        },
        enumerable: false,
        configurable: true
    });
    PlayByPlayState.prototype.pushEntry = function (entry) {
        var entryCount = this.allEntriesImmutable.count();
        var result = this.updateIn([PlayByPlayState.entriesKey], function (entries) {
            return entries.push(entry);
        });
        if (entry.eventIds) {
            entry.eventIds.forEach(function (eventId) { return (result = result.setIn([PlayByPlayState.eventIdIndexMapKey, eventId], entryCount)); });
        }
        return result;
    };
    PlayByPlayState.prototype.entryForEventId = function (eventId) {
        var index = this.getIn([PlayByPlayState.eventIdIndexMapKey, eventId]);
        if (index === undefined) {
            return undefined;
        }
        var entry = this.getIn([PlayByPlayState.entriesKey, index]);
        if (entry === undefined) {
            throw new controller_1.InvalidEventIndexError(index);
        }
        return {
            entry: entry,
            index: index,
        };
    };
    PlayByPlayState.isInProgressKey = 'isInProgress';
    PlayByPlayState.inProgressEntriesKey = 'inProgressEntries';
    PlayByPlayState.entriesKey = 'entries';
    PlayByPlayState.eventIdIndexMapKey = 'eventIdIndexMap';
    PlayByPlayState.latestScorerStreakKey = 'latestScorerStreak';
    return PlayByPlayState;
}(state.ImmutableState));
exports.PlayByPlayState = PlayByPlayState;
exports.playByPlayEntry = Immutable.Record({
    id: '',
    template: '',
    playByPlayType: '',
    eventIds: undefined,
    playCode: undefined,
    playerStats: undefined,
    teamId: undefined,
    playerId: undefined,
    playerAssignmentEventId: undefined,
    period: undefined,
    teamScores: undefined,
    periodScores: undefined,
    scoreAdjustment: undefined,
    playerEdited: undefined,
    playerAssignable: false,
    teamAssignable: false,
    deletable: false,
    createdAt: undefined,
    summary: undefined,
    playDetails: undefined,
    initialState: undefined,
    colorCommentary: undefined,
});
var PlayByPlayEntry = /** @class */ (function (_super) {
    tslib_1.__extends(PlayByPlayEntry, _super);
    function PlayByPlayEntry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PlayByPlayEntry;
}(exports.playByPlayEntry));
exports.PlayByPlayEntry = PlayByPlayEntry;
var MultiSportPlayByPlayEngine = /** @class */ (function (_super) {
    tslib_1.__extends(MultiSportPlayByPlayEngine, _super);
    function MultiSportPlayByPlayEngine(baseEvents, confirguration, activePlayer, period, score, stats) {
        var _this = _super.call(this, baseEvents) || this;
        _this.baseEvents = baseEvents;
        _this.confirguration = confirguration;
        _this.activePlayer = activePlayer;
        _this.period = period;
        _this.score = score;
        _this.stats = stats;
        _this.playsForStreakTracking = [];
        _this.playsForStreakBreaking = [];
        return _this;
    }
    MultiSportPlayByPlayEngine.prototype.initialState = function () {
        return new PlayByPlayState(Immutable.fromJS({
            entries: [],
            eventIdIndexMap: {},
            isInProgress: false,
            inProgressEntriesKey: {},
            latestScorerStreak: {},
        }));
    };
    MultiSportPlayByPlayEngine.prototype.processOneEvent = function (immutable, event) {
        var _this = this;
        switch (event.code) {
            case definitions_1.MultiSportEventCode.BeginPlay:
                return this.handleBeginPlay(immutable, event);
            case definitions_1.MultiSportEventCode.EndPlay:
                return this.handleEndPlay(immutable, event);
            case definitions_1.MultiSportEventCode.Play:
                return (0, definitions_1.onValidPlayCode)(immutable, event, this.confirguration.play_codes, function (immState, play) {
                    return _this.handlePlay(immState, play);
                });
            case definitions_1.MultiSportEventCode.EndPeriod:
                return this.handleEndPeriod(immutable, event);
            case definitions_1.MultiSportEventCode.AssignPlayer:
                return this.handleAssignPlayer(immutable, event);
            case definitions_1.MultiSportEventCode.ActivatePlayer:
                return this.handleActivatePlayer(immutable, event);
            case definitions_1.MultiSportEventCode.DeactivatePlayer:
                return this.handleDeactivatePlayer(immutable, event);
            case definitions_1.MultiSportEventCode.AdjustScore:
                return this.handleAdjustScore(immutable, event);
            case definitions_1.MultiSportEventCode.OverrideScore:
                return this.handleOverrideScore(immutable, event);
            default:
                return immutable;
        }
    };
    MultiSportPlayByPlayEngine.prototype.handleBeginPlay = function (immutable, _event) {
        return immutable;
    };
    MultiSportPlayByPlayEngine.prototype.handleEndPlay = function (immutable, _event) {
        return immutable;
    };
    MultiSportPlayByPlayEngine.prototype.getColorCommentaryMaybe = function (_stats, _playByPlayState, _playCode, _playerId, _teamId) {
        return undefined;
    };
    MultiSportPlayByPlayEngine.prototype.handleEndPeriod = function (immutable, endPeriod) {
        var period = this.period.stateBeforeEvent(this.nextEventOffset);
        var score = this.score.stateAfterEvent(this.nextEventOffset);
        var entry = new PlayByPlayEntry(Immutable.fromJS({
            template: "End of period ".concat(period === null || period === void 0 ? void 0 : period.period),
            id: "end_of_period_".concat(period === null || period === void 0 ? void 0 : period.period),
            playByPlayType: PlayByPlayType.EndPeriod,
            eventIds: [endPeriod.id],
            period: period === null || period === void 0 ? void 0 : period.period,
            teamScores: score === null || score === void 0 ? void 0 : score.scoresImmutable,
            playerAssignable: false,
            teamAssignable: false,
            deletable: true,
            createdAt: endPeriod.createdAt,
            summary: this.getEndPeriodSummary(period.period, score, period.periodType),
        }));
        return immutable.pushEntry(entry);
    };
    MultiSportPlayByPlayEngine.prototype.getEndPeriodSummary = function (_period, _scoreState, _periodType) {
        return undefined;
    };
    MultiSportPlayByPlayEngine.prototype.handleAssignPlayer = function (immutable, assignPlayer) {
        var _a;
        var playId = assignPlayer.attributes.play_event_id;
        var entryData = immutable.entryForEventId(playId);
        if (entryData === undefined) {
            // We don't know about the play.
            // We might want to throw an exception but for now we'll just ignore the assignplayer event.
            return immutable;
        }
        var oldEntryIndex = entryData.index;
        var oldEntry = entryData.entry;
        if (oldEntry.eventIds === undefined) {
            throw new Error('entry is missing eventId');
        }
        var playerId = assignPlayer.attributes.player_id;
        var stats = (_a = this.stats) === null || _a === void 0 ? void 0 : _a.stateAfterEvent(this.nextEventOffset);
        if (oldEntry.playCode && oldEntry.teamId) {
            if (this.playsForStreakTracking.includes(oldEntry.playCode)) {
                immutable = immutable.trackLatestScore(oldEntry.teamId, playerId);
            }
            else if (this.playsForStreakBreaking.includes(oldEntry.playCode)) {
                immutable = immutable.trackLatestMiss(oldEntry.teamId, playerId);
            }
        }
        var colorCommentary = undefined;
        if (oldEntry.playCode && oldEntry.teamId && stats) {
            colorCommentary = this.getColorCommentaryMaybe(stats, immutable, oldEntry.playCode, playerId, oldEntry.teamId);
        }
        var updatedEntry = new PlayByPlayEntry(Immutable.fromJS({
            template: "".concat(oldEntry.playCode, " by ").concat(playerId),
            id: oldEntry.id,
            playByPlayType: PlayByPlayType.Play,
            eventIds: oldEntry.eventIds,
            playCode: oldEntry.playCode,
            playerStats: stats === null || stats === void 0 ? void 0 : stats.stats[oldEntry.teamId]['players'][playerId],
            teamId: oldEntry.teamId,
            period: oldEntry.period,
            playerId: playerId,
            playerAssignmentEventId: assignPlayer.id,
            teamScores: oldEntry.teamScores,
            playerEdited: assignPlayer.attributes.is_edit,
            playerAssignable: true,
            teamAssignable: true,
            deletable: true,
            createdAt: oldEntry.createdAt,
            colorCommentary: colorCommentary,
            summary: (0, play_by_play_commentary_1.getPlayCommentary)(oldEntry.playCode, playerId),
        }));
        var activePlayer = this.activePlayer.stateBeforeEvent(this.nextEventOffset);
        if (activePlayer === null || activePlayer === void 0 ? void 0 : activePlayer.isPlayerActive(oldEntry.teamId, playerId)) {
            // Player was already active
            return immutable.setIn(['entries', oldEntryIndex], updatedEntry);
        }
        else {
            // Need extra implicit player activation.
            var implicitActivationEntry_1 = new PlayByPlayEntry(Immutable.fromJS({
                template: "".concat(playerId, " entered the game"),
                id: "".concat(oldEntry.id, "_implicit_activate"),
                playByPlayType: PlayByPlayType.ImplicitPlayerActivate,
                teamId: oldEntry.teamId,
                period: oldEntry.period,
                playerId: playerId,
                playerAssignable: false,
                teamAssignable: false,
                deleteable: false,
                createdAt: oldEntry.createdAt,
                summary: this.getActivatePlayerSummary(playerId),
            }));
            return immutable
                .updateIn(['entries'], function (entries) {
                return entries.set(oldEntryIndex, updatedEntry).insert(oldEntryIndex, implicitActivationEntry_1);
            })
                .setIn(tslib_1.__spreadArray(['eventIdIndexMap'], oldEntry.eventIds.toArray(), true), oldEntryIndex + 1);
        }
    };
    MultiSportPlayByPlayEngine.prototype.handleActivatePlayer = function (immutable, activatePlayer) {
        var teamId = activatePlayer.attributes.team_id;
        var playerId = activatePlayer.attributes.player_id;
        var period = this.period.stateBeforeEvent(this.nextEventOffset);
        var activePlayer = this.activePlayer.stateBeforeEvent(this.nextEventOffset);
        if (activePlayer === null || activePlayer === void 0 ? void 0 : activePlayer.isPlayerActive(teamId, playerId)) {
            // player was already active, so ignore this.
            return immutable;
        }
        var entry = new PlayByPlayEntry(Immutable.fromJS({
            template: "".concat(playerId, " entered the game"),
            id: activatePlayer.attributes.pbp_entry_id,
            playByPlayType: PlayByPlayType.PlayerActivate,
            eventIds: [activatePlayer.id],
            teamId: teamId,
            period: period === null || period === void 0 ? void 0 : period.period,
            playerId: playerId,
            playerAssignable: true,
            teamAssignable: false,
            deletable: true,
            createdAt: activatePlayer.createdAt,
            summary: this.getActivatePlayerSummary(playerId),
        }));
        return immutable.pushEntry(entry);
    };
    MultiSportPlayByPlayEngine.prototype.getActivatePlayerSummary = function (_playerId) {
        return undefined;
    };
    MultiSportPlayByPlayEngine.prototype.handleDeactivatePlayer = function (immutable, deactivatePlayer) {
        var teamId = deactivatePlayer.attributes.team_id;
        var playerId = deactivatePlayer.attributes.player_id;
        var period = this.period.stateBeforeEvent(this.nextEventOffset);
        var activePlayer = this.activePlayer.stateBeforeEvent(this.nextEventOffset);
        if (!(activePlayer === null || activePlayer === void 0 ? void 0 : activePlayer.isPlayerActive(teamId, playerId))) {
            // player was already inactive, so ignore this.
            return immutable;
        }
        var entry = new PlayByPlayEntry(Immutable.fromJS({
            template: "".concat(playerId, " sat down"),
            id: deactivatePlayer.attributes.pbp_entry_id,
            playByPlayType: PlayByPlayType.PlayerDeactivate,
            eventIds: [deactivatePlayer.id],
            teamId: teamId,
            period: period === null || period === void 0 ? void 0 : period.period,
            playerId: playerId,
            playerAssignable: true,
            teamAssignable: false,
            deletable: true,
            createdAt: deactivatePlayer.createdAt,
            summary: this.getDeactivatePlayerSummary(playerId),
        }));
        return immutable.pushEntry(entry);
    };
    MultiSportPlayByPlayEngine.prototype.getDeactivatePlayerSummary = function (_playerId) {
        return undefined;
    };
    MultiSportPlayByPlayEngine.prototype.handleAdjustScore = function (immutable, event) {
        var teamId = event.attributes.team_id;
        var scoreAdjustment = event.attributes.adjustment;
        var score = this.score.stateAfterEvent(this.nextEventOffset);
        var period = this.period.stateBeforeEvent(this.nextEventOffset);
        var entry = new PlayByPlayEntry(Immutable.fromJS({
            template: "Score adjusted: ".concat(scoreAdjustment, " for ").concat(teamId),
            id: event.attributes.pbp_entry_id,
            playByPlayType: PlayByPlayType.ScoreAdjustment,
            eventIds: [event.id],
            teamId: teamId,
            period: period === null || period === void 0 ? void 0 : period.period,
            teamScores: score === null || score === void 0 ? void 0 : score.scoresImmutable,
            scoreAdjustment: scoreAdjustment,
            playerAssignable: false,
            teamAssignable: true,
            deletable: true,
            createdAt: event.createdAt,
            summary: this.getAdjustScoreSummary(score.scores[score.awayId], score.scores[score.homeId]),
        }));
        return immutable.pushEntry(entry);
    };
    MultiSportPlayByPlayEngine.prototype.getAdjustScoreSummary = function (_awayScore, _homeScore) {
        return undefined;
    };
    MultiSportPlayByPlayEngine.prototype.handleOverrideScore = function (immutable, event) {
        var _a;
        var teamId = event.attributes.team_id;
        var oldPoints = (_a = this.score.stateBeforeEvent(this.nextEventOffset)) === null || _a === void 0 ? void 0 : _a.scores[teamId];
        var newScore = this.score.stateAfterEvent(this.nextEventOffset);
        var adjustment = newScore.scores[teamId] - oldPoints;
        var period = this.period.stateBeforeEvent(this.nextEventOffset);
        var entry = new PlayByPlayEntry(Immutable.fromJS({
            template: "Score adjusted: ".concat(adjustment, " for ").concat(teamId),
            id: event.attributes.pbp_entry_id,
            playByPlayType: PlayByPlayType.ScoreOverride,
            eventIds: [event.id],
            teamId: teamId,
            period: period === null || period === void 0 ? void 0 : period.period,
            teamScores: newScore === null || newScore === void 0 ? void 0 : newScore.scoresImmutable,
            scoreAdjustment: adjustment,
            playerAssignable: false,
            teamAssignable: true,
            deletable: true,
            createdAt: event.createdAt,
        }));
        return immutable.pushEntry(entry);
    };
    return MultiSportPlayByPlayEngine;
}(engine.VersionedStateEngine));
exports.MultiSportPlayByPlayEngine = MultiSportPlayByPlayEngine;
//# sourceMappingURL=play_by_play_engine.js.map